import t from '@rcm/i18n-client';
import React from 'react';
import { Button } from 'react-bootstrap';
import useShippingCanSubmit from '../../hooks/useShippingCanSubmit';

const ShippingSubmitButton = () => {
    const disabled = !useShippingCanSubmit();

    return <Button type="submit" disabled={disabled}>
        {t('Continue')}
    </Button>;
}

export default ShippingSubmitButton;
